import { render, staticRenderFns } from "./Vender.vue?vue&type=template&id=08541d75&scoped=true&"
import script from "./Vender.vue?vue&type=script&lang=js&"
export * from "./Vender.vue?vue&type=script&lang=js&"
import style0 from "./Vender.vue?vue&type=style&index=0&id=08541d75&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08541d75",
  null
  
)

export default component.exports